import { defineMessages } from 'react-intl';

import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const messages = defineMessages({
  anchorId: {
    id: 'Anchor id',
    defaultMessage: 'Anchor id',
  },
});
export const anchorStyleSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });

  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'anchorId',
  ];
  schema.properties.styles.schema.properties.anchorId = {
    title: intl.formatMessage(messages.anchorId),
    default: '',
  };

  return schema;
};
